// extracted by mini-css-extract-plugin
export var container = "_du-0";
export var popoverContent = "_du-1";
export var tosLink = "_du-2";